module.exports = __webpack_public_path__ + "static/media/codeDeactivate.c3d2225a.png";